export default __webpack_public_path__ + "pgnv-assets/e1a52addd489b6c0a5a82b9b016de84d.svg";